import * as React from 'react';
import './Form.scss';
import { observer } from "mobx-react";

const Form: React.FunctionComponent<React.DetailedHTMLProps<React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>> = props => {
	const {
		children,
		...rest
	} = props;
	return (
		<form className='Form' {...rest}>
			{children}
		</form>
	);
};

export default observer(Form);
